exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Primary */\n/* Support */\n/* Attention */\n/* Other colors e.g. graphs */\n/* Text */\n/* Statuses */\n/* Tooltip */\n/* Toast a.k.a. notes */\n/* Pseudo classes */\n/* Backgrounds */\n/* Buttons */\n/* Date picker */\n/* Select */\n/* Grids */\n\n.icons-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; }\n  .icons-container h3 {\n    margin-left: 10px; }\n  .icons-container .icon-container {\n    margin: 10px;\n    min-width: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column; }\n    .icons-container .icon-container svg {\n      margin-bottom: 10px; }\n    .icons-container .icon-container.logo svg {\n      background-color: #EC6608; }\n", ""]);

// exports
exports.locals = {
	"colorPrimaryOrange": "#EC6608",
	"colorPrimaryYellow": "#FECA1D",
	"colorPrimarAzure": "#67707c",
	"colorBackgroundAside": "#EAEFF3",
	"colorBackgroundMenu": "#3C4A55",
	"colorMain": "#EC6608",
	"colorBlack": "#000000",
	"colorPetrol": "#006070",
	"colorDarkSteel": "#3B4A56",
	"colorSupportGray": "#CCCCCC",
	"colorLightGray": "#D3DADE",
	"colorAttentionRed": "#DD2515",
	"colorAttentionGreen": "#3AA57B",
	"colorYellow": "#FECA1D",
	"colorOrange": "#E66608",
	"colorGreen": "#3AA57B",
	"colorAzure": "#67707C",
	"colorGray": "#CCCCCC",
	"colorRed": "#D82515",
	"colorBlue": "#16AED6",
	"colorViolet": "#943BA3",
	"colorWhite": "#FFFFFF",
	"colorText": "#67707c",
	"colorTextLink": "#EC6608",
	"colorTextDisabled": "#a7a7a7",
	"colorWarning": "#FECA1D",
	"colorSuccess": "#3AA57B",
	"colorError": "#D82515",
	"colorInfo": "#16AED6",
	"colorTooltipText": "#FFFFFF",
	"colorTooltipBackground": "#006070",
	"colorToastText": "#000000",
	"colorToastBackground": "#eaeaea",
	"colorPseudoNormal": "#67707c",
	"colorPseudoFocused": "#FECA1D",
	"colorPseudoHover": "#FECA1D",
	"colorPseudoPressed": "#FECA1D",
	"colorPseudoDisabled": "#a7a7a7",
	"colorContentBackground": "#FFFFFF",
	"colorSiteBackground": "#D3DADE",
	"colorButtonText": "#FFFFFF",
	"colorButtonTextDisabled": "#a7a7a7",
	"colorButtonNormal": "#67707c",
	"colorButtonFocused": "#67707c",
	"colorButtonHover": "#77818c",
	"colorButtonPressed": "#585F68",
	"colorButtonPriorityNormal": "#E66608",
	"colorButtonPriorityFocused": "#E66608",
	"colorButtonPriorityHover": "#ff7517",
	"colorButtonPriorityPressed": "#d35c0b",
	"colorButtonDisabled": "#f0f0f0",
	"colorDatePickerContent": "#E9E9E9",
	"colorSelectHover": "#eff2f4",
	"colorSelectSelected": "#e6e9eb",
	"colorGridText": "#67707c",
	"colorGridBorder": "#D3DADE",
	"colorGridBackground": "#FFFFFF",
	"colorGridStripe": "#D3DADE",
	"colorGridHighlight": "#eff2f4",
	"colorGridSelected": "#e6e9eb"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/postcss-loader/lib??ref--3-2!../node_modules/sass-loader/lib/loader.js!./components/icons-view.component.scss
// module id = 509
// module chunks = 0